<template>
  <div class="temp-home-page">
    <div class="temp-container">
      <div class="temp-content">
        <h1>商栈平台</h1>
        <p class="platform-info">本平台地址为：<a href="http://erp.shangzhanyun.com" target="_blank" class="platform-link">erp.shangzhanyun.com</a></p>
        <div class="actions">
          <button class="secondary-btn">进入后请收藏</button>
          <a href="http://erp.shangzhanyun.com" class="primary-btn">点击进入</a>
        </div>
      </div>
    </div>
    
    <!-- 底部备案信息 -->
    <div class="footer-beian">
      <p>软件企业编号：沪CR-2013-0914 | 备案号：<a href="https://beian.miit.gov.cn/" target="_blank" class="beian-link">沪ICP备16016473号</a> | 2025 上海奔云信息科技有限公司</p>
    </div>
  </div>
</template>

<script setup>
import { defineComponent } from 'vue';

defineComponent({
  name: 'TempHomePage'
});
</script>

<style scoped>
.temp-home-page {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 20px;
}

.temp-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.temp-content {
  max-width: 600px;
  width: 100%;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 40px;
  text-align: center;
}

.temp-content h1 {
  font-size: 32px;
  color: #333;
  margin-bottom: 20px;
}

.platform-info {
  font-size: 20px;
  margin-bottom: 30px;
}

.platform-link {
  color: #1890ff;
  font-weight: bold;
  text-decoration: underline;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.primary-btn, .secondary-btn {
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}

.primary-btn {
  background-color: #1890ff;
  color: white;
  text-decoration: none;
}

.primary-btn:hover {
  background-color: #40a9ff;
}

.secondary-btn {
  background-color: #f0f0f0;
  color: #333;
  cursor: default;
}

/* 底部备案信息样式 */
.footer-beian {
  width: 100%;
  text-align: center;
  padding: 15px 0;
  border-top: 1px solid #e8e8e8;
  margin-top: 20px;
}

.footer-beian p {
  font-size: 12px;
  color: #666;
}

.beian-link {
  color: #666;
  text-decoration: none;
}

.beian-link:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .temp-container {
    padding: 10px;
  }
  
  .temp-content {
    padding: 30px 20px;
  }
  
  .actions {
    flex-direction: column;
    gap: 10px;
  }
  
  .primary-btn, .secondary-btn {
    width: 100%;
  }
}
</style>
